import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
const YardMisReport = ({ selectedDate }) => {
  const token = Cookies.get("token")?.replace(/"/g, "");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const [misReport, setMisReport] = useState([]);
  const getMisData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/yard-details/yard-details-mis-report/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        date: selectedDate,
      }),
    });
    const result = await res.json();
    if (res.ok) {
      setMisReport(result.data);
    } else {
    }
  };

  useEffect(() => {
    getMisData();
  }, [selectedDate]);
  const moldKeys =
    misReport?.length > 0 ? Object?.keys(misReport[0].MOULD) : [];
  const stockKeys =
    misReport?.length > 0 ? Object?.keys(misReport[0]["STOCK YARD"]) : [];
  const componentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    pageStyle: `
      @page {
        size: auto !important;
      }
      body {
       
      }
      @media print {
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          border-spacing: 0;
          margin-bottom: 10px;
          transform: scale(0.9);
        }
        th, td {
          border: 1px solid #ddd;
          padding: 10px;
          font-family: 'Arial', sans-serif !important;
          font-size: 14px !important;
        }
      }`,
    documentTitle: "Yard MIS Report",
  });
  return (
    <>
      <div className="btn_container d-flex justify-content-between flex-wrap">
        <button onClick={generatePDF} className="btn btn-primary mb-3">
          Generate PDF
        </button>
      </div>
      <div className="row" id="pdf-content">
        <div className="col-lg-12 grid-margin stretch-card">
          <div
            className="table-responsive table-bordered"
            style={{ border: "0.05px solid lightGray" }}
          >
            <table className="table table-hover" ref={componentPDF} style={{ fontSize: "14px" }}>
              <thead>
                <tr style={{ textAlign: "center" }}>
                  <th colSpan="1">DATE: {selectedDate} </th>
                  <th colSpan={moldKeys?.length}>MOULD</th>
                  <th colSpan={stockKeys?.length}>STOCK YARD</th>
                </tr>
                <tr>
                  <th>FACTORY NAME</th>
                  {moldKeys?.map((key, index) => (
                    <th key={index}>{key}</th>
                  ))}
                  {stockKeys?.map((key, index) => (
                    <th key={index}>{key}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {misReport &&
                  misReport?.length > 0 &&
                  misReport?.map((factory) => (
                    <tr key={factory["FACTORY NAME"]}>
                      <td
                        style={{
                          textTransform: "uppercase",
                          fontWeight: "bold",
                          fontFamily: "Arial, sans-serif",
                        }}
                      >
                        {factory["FACTORY NAME"]}
                      </td>
                      {moldKeys.map((key, index) => (
                        <td key={index}>{factory.MOULD[key]}</td>
                      ))}
                      {stockKeys.map((key, index) => (
                        <td key={index} style={{ fontWeight: "bold" }}>
                          {factory["STOCK YARD"][key]}
                        </td>
                      ))}
                    </tr>
                  ))}
                {/* Grand Total Row */}
                <tr>
                  <td
                    style={{
                      textTransform: "uppercase",
                      borderTop: "3px solid lightGray",
                    }}
                  >
                    Grand Total
                  </td>

                  {moldKeys?.map((key, index) => (
                    <td
                      key={index}
                      style={{ borderTop: "3px solid lightGray" }}
                    >
                      {misReport.reduce(
                        (total, factory) =>
                          total + (parseInt(factory.MOULD[key]) || 0),
                        0
                      )}
                    </td>
                  ))}
                  {stockKeys?.map((key, index) => (
                    <td
                      key={index}
                      style={{ borderTop: "3px solid lightGray" }}
                    >
                      {misReport.reduce(
                        (total, factory) =>
                          total + (parseInt(factory["STOCK YARD"][key]) || 0),
                        0
                      )}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default YardMisReport;
